import Helmet from 'react-helmet'

const MetaDetail = props => {
  const scripts = []
  function htmlDecode (content) {
    let e = document.createElement('div')
    e.innerHTML = content
    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue
  }

  if (props.script) {
    props.script.forEach(s => {
      scripts.push(s)
    })
  }
  return (
    <Helmet script={scripts}>
      <title>{htmlDecode(props.meta.title)}</title>
      <meta name='description' content={htmlDecode(props.meta.description)} />
			<link rel='canonical' href={props.meta.canonical} />
    </Helmet>
  )
}

export default MetaDetail



// WEBPACK FOOTER //
// ./src/components/_common/MetaDetail/index.js